import React, { memo } from 'react';
import { Tabs } from 'antd';

const MediaTypeTabs = (props) => {

    const {
        style = {},
        bodyStyle = {},
        tabChange = () => {},
        tabKey,
        nav=[],
        tabBarStyle={},
    } = props;

    return (
        <div style={style}>
            <Tabs
                className={'tabs'}
                activeKey={tabKey}
                style={bodyStyle}
                tabBarStyle={tabBarStyle}
                onChange={(tabKey) => {
                    tabChange(tabKey)
                }}
            >
                {
                    nav.map(item=>(
                        <Tabs.TabPane key={item.key} tab={
                            <span>
                                {item.src ? <img style={{width: 16, objectFit: 'cover',marginRight:5, }} src={item.src} alt=""/> : null}
                                {item.name}
                            </span>
                        } />
                    ))
                }
            </Tabs>
        </div>
    )

}
export default memo(MediaTypeTabs);